export const submitSurvey = `
  mutation surveyFeedbackCreateByHandle($handle: String!, $input: CreateSurveyFeedbackInput!) {
    surveyFeedbackCreateByHandle(handle: $handle, input: $input) {
      id
    }
  }
`
